import { useEffect } from "react";
import SearchTermOperation from "../../../../components/Paid Traffic/Methodology/SearchTermOperations/SearchTermOperation";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { selectUserData } from "../../../../features/userSlice";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../../components/Page404/Page403";
import { resetStateOfScopesTab } from "../../../../features/scopesTabSlice";
import { resetStateOfSearchTermTab } from "../../../../features/searchTermTabSlice";
import { resetStateOfAiRecomendationTab } from "../../../../features/aiRecomendationTabSlice";

const SearchTermOperationsScreen = () => {
  // let react_env = import.meta.env.VITE_ENV;
  const response = useSelector(selectUserData);
  const dispatch = useDispatch();
  const hasViewSTOPermission = CheckPermissions(
    response?.data?.products?.paid_traffic,
    "plan_campaign_ppc",
    "view_st_account_management"
  );

  //--Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(resetStateOfScopesTab()); // Reset STO scopes tab state
      dispatch(resetStateOfSearchTermTab()); // Reset STO search term tab state
      dispatch(resetStateOfAiRecomendationTab());
    };
  }, [dispatch]);

  return (
    <>
      {hasViewSTOPermission ? (
        <>
          <SearchTermOperation />
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default SearchTermOperationsScreen;
